import { render, staticRenderFns } from "./ZonaDescagas.vue?vue&type=template&id=51526b38&"
import script from "./ZonaDescagas.vue?vue&type=script&lang=js&"
export * from "./ZonaDescagas.vue?vue&type=script&lang=js&"
import style0 from "./ZonaDescagas.vue?vue&type=style&index=0&id=51526b38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports